import { param } from 'jquery';
import api from './core';

const orgStructure = {
  accessRolesList,
  getCompanySubsidiriesList,
  getCompanyRoles,
  getCompanyEmployees,
  assignRoleTOUsers,
  reportingStructure,
  getAllEmployeesInHeirarchy,
  assignRolesToUser,
  assignReporting,
  patchReporting,
  overwriteReporting,
  getEmployeeForTermination,
  getempRolesList,
  getEmployeesByCompanyIdAndLanguage,
  getEmployeeByCompanyAndDep,
  getEmployeesCountByCompanyId,
  getManagerReportees,
  replaceEmployeeRole,
  getEmployeesIdsByCompanyId,
  facereportingStructure,
};
function replaceEmployeeRole(payload) {
  return new Promise((resolve, reject) => {
    api
      .post(
        `/v2/replacerole?locale=${localStorage.getItem('applang')}`,
        payload,
      )
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
function getEmployeeByCompanyAndDep(payload) {
  return new Promise((resolve, reject) => {
    api
      .get(`/v2/lookups/employees?locale=${localStorage.getItem('applang')}`, {
        params: payload,
      })
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
function accessRolesList(searchName) {
  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/accessRolesList?searchName=${searchName}&locale=${localStorage.getItem('applang')}`,
      )
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
function getempRolesList($roleId) {
  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/getEmpListByRoleId?roleId=${$roleId}&locale=${localStorage.getItem(
          'applang',
        )}`,
      )
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getManagerReportees(manageruserid, role_id, pageFrom) {
  return new Promise((resolve, reject) => {
    api
      .get(
        `/v2/managerReportees?manageruserid=${manageruserid}&managerRoleId=${role_id}&locale=${localStorage.getItem('applang')}${
          pageFrom ? `&pageFrom=${pageFrom}` : ''
        }`,
      )
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function reportingStructure(
  companyId,
  page,
  rowsPerPage,
  searchName,
  orderBy = null,
  DepID = 0,
) {
  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/reportingStructure?company_id=${companyId}&page=${page}&rowsPerPage=${rowsPerPage}&searchName=${searchName}&orderBy=${orderBy}&DepID=${DepID}&locale=${localStorage.getItem('applang')}`,
      )
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function facereportingStructure(
  companyId,
  page,
  rowsPerPage,
  searchName,
  orderBy = null,
  DepID = 0,
) {
  return new Promise((resolve, reject) => {
    api
      .get(
        `/v1/facereportingStructure?company_id=${companyId}&page=${page}&rowsPerPage=${rowsPerPage}&searchName=${searchName}&orderBy=${orderBy}&DepID=${DepID}&locale=${localStorage.getItem('applang')}`,
      )
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function assignReporting(params) {
  return new Promise((resolve, reject) => {
    api
      .post(`/v1/reportingStructure`, params)
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function overwriteReporting(params) {
  return new Promise((resolve, reject) => {
    api
      .post(`/v1/reportingStructure/overwrite`, params)
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function patchReporting(params) {
  return new Promise((resolve, reject) => {
    api
      .put(`/v1/reportingStructure`, params)
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getCompanyRoles(companyId) {
  return new Promise((resolve, reject) => {
    api
      .get(`/v1/getRoles?locale=${localStorage.getItem('applang')}`, {
        params: {
          companyId: companyId,
        },
      })
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getCompanyEmployees(
  companyId,
  page,
  rowsPerPage,
  searchText,
  selectAll,
  depID,
) {
  return new Promise((resolve, reject) => {
    api
      .get(`/v1/getCompanyEmployees`, {
        params: {
          companyId: companyId,
          locale: localStorage.getItem('applang'),
          deptId: depID,
          page: page,
          searchName: searchText,
          rowsPerPage: rowsPerPage,
          selectAll: selectAll ?? 0,
        },
      })
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
function getEmployeeForTermination(companyId, page, perPage, searchTerm) {
  return new Promise((resolve, reject) => {
    api
      .get(`/v1/getEmployeesforTermin`, {
        params: {
          companyId: companyId,
          searchTerm: searchTerm,
          page: page,
          perPage: perPage,
          locale: localStorage.getItem('applang'),
        },
      })
      .then((result) => {
        return resolve(result?.data?.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}
function getAllEmployeesInHeirarchy(companyId, locale = 'en') {
  return new Promise((resolve, reject) => {
    api
      .get(`/v1/getSubsidaryEmployees/${companyId}`, {
        params: {
          companyId: companyId,
          locale: locale,
        },
      })
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getEmployeesByCompanyIdAndLanguage(
  companyId,
  locale = 'en',
  name = null,
  isnotassigned,
  skip = 0,
  limit = 100,
) {
  return new Promise((resolve, reject) => {
    api
      .get(`/v2/lookups/get-employees`, {
        params: {
          companyId: companyId,
          locale: locale,
          name: name,
          skip: skip,
          limit: limit,
          isnotassigned: isnotassigned,
        },
      })
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getEmployeesCountByCompanyId(companyId, locale = 'en') {
  return new Promise((resolve, reject) => {
    api
      .get(`/v2/lookups/get-employees-count`, {
        params: {
          companyId: companyId,
          locale: locale,
        },
      })
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getEmployeesIdsByCompanyId(companyId, locale = 'en') {
  return new Promise((resolve, reject) => {
    api
      .get(`/v2/lookups/get-employees-ids`, {
        params: {
          companyId: companyId,
          locale: locale,
        },
      })
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getCompanySubsidiriesList(cid) {
  return new Promise((resolve, reject) => {
    api
      .get(
        cid
          ? `/v1/companySubsidaries?companyId=` +
              cid +
              `&locale=${localStorage.getItem('applang')}`
          : `/v1/companySubsidaries?locale=${localStorage.getItem('applang')}`,
      )
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function assignRoleTOUsers(companyId, roleId, userIds) {
  return new Promise((resolve, reject) => {
    var postData = {
      companyId: companyId,
      roleId: roleId,
      userIds: userIds,
    };

    api
      .post(`/v1/reportingStructure/assignUsersRole`, postData)
      .then((result) => {
        return resolve('success');
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function assignRolesToUser(payload) {
  return new Promise((resolve, reject) => {
    api
      .post(`/v1/reportingStructure/assignUsersRoles `, payload)
      .then((result) => {
        return resolve(result.data.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

export default orgStructure;
